import React, { useEffect, useState } from 'react'
import  { Page1FormData } from '../createStoreForms/StorePageOneForm'
import { useForm } from 'react-hook-form';
import GoogleMapComponent from '../createStoreForms/GoogleMap';
import SubTitle from '../../ui/SubTitle';
import { useSingleStoreAction } from '../../../hooks/store/store';
import LoadingErrorState from '../../ui/LoadingErrorState';
import SubmitButton from '../../form/SubmitButton';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../form/LoadingButton';
import { useParams } from 'react-router-dom';
import { cities } from '../../../data/cities';

export default function UpdateStoreGeneral() {
    const {t} = useTranslation();
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
    const {data:store,isError,isLoading} = useSingleStoreAction(numericStoreId);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm<Page1FormData>({
        defaultValues: { commercialRegister:store?.commercialRegister, taxNumber:store?.taxNumber, city:store?.city}
      });
    const [mapPosition, setMapPosition] = useState<{ lat: number; lng: number } | null>(null);
      useEffect(() => {
        if (store && store.lat && store.lng) {
          setMapPosition({ lat: store.lat, lng: store.lng });
          setValue("commercialRegister", store.commercialRegister);
          setValue("taxNumber", store.taxNumber);
          setValue("city", store.city);
        }
      }, [store, setValue]);

      

       const { loading, updateResource } = useUpdateResource();
      
        const onSubmit = (data: Page1FormData) => {
          // call API to create category
          const url =numericStoreId?`store?storeId=${numericStoreId}`:"store";
          updateResource(url, {city:data.city , lat:mapPosition?.lat,lng:mapPosition?.lng},numericStoreId? "admin":"store",{
            method: "PUT",
            successMessage: t("update_success"),
            invalidateQueries:["store-detail-action"],
          });
        };

  return (
    <div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
        <form className="flex flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
            {
              store && 
              <>
              <div>
              <SubTitle title="select_location"/>
              {mapPosition && (
              <GoogleMapComponent
                lat={mapPosition.lat}
                lng={mapPosition.lng}
                onLocationChange={(lat, lng) => setMapPosition({ lat, lng })}
              />
            )}
              </div>
              <div className='mt-8'>
                  {/* <StorePageOneForm register={register} errors={errors}/> */}
                  <div className="mt-4">
                          <SubTitle title={t('selectCity')} />
                          <select
                            {...register("city", { required: t("required_field") })}
                            className="border border-LightGrey3  rounded p-3 mt-2 w-full  focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-sm"
                          >
                            <option value="">{t('selectCity')}</option>
                            {cities.map((c) => (
                              <option key={c} value={c}>
                                {c}
                              </option>
                            ))}
                          </select>
                          {errors.city && <span className="text-red-500">{errors.city.message}</span>}
                        </div>
              </div>
              </>
            }
            <div className=''>
              {
                loading 
                ?
                <LoadingButton/>
                :
                <SubmitButton label='update'/>
              }
            </div>
        </form>
    </div>
  )
}
